import { render } from "./ArticleView.vue?vue&type=template&id=21f990a0&ts=true"
import script from "./ArticleView.vue?vue&type=script&lang=ts"
export * from "./ArticleView.vue?vue&type=script&lang=ts"

import "./ArticleView.vue?vue&type=style&index=0&id=21f990a0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__